import { Injectable } from '@angular/core';

import { ApiService, OperationService } from '@app/services';
import { PermanentAgent } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class PermanentAgentService {

    static PermanentsAgents: Array<PermanentAgent> = [];

    constructor(
        private apiService: ApiService
    ) {}

    async init(){   
        PermanentAgentService.PermanentsAgents = await this.loadPermanentsAgents(); 
    }
    
    reset(){        
        PermanentAgentService.PermanentsAgents = [];
    }
        
    async loadPermanentsAgents(operationId?: number): Promise <PermanentAgent[]>{
        let permanentsAgents: Array<PermanentAgent> = [];
        let params: any = {};
        
        if(operationId){
            params.ctxId = operationId;
            let response = await this.apiService.get('sales-rep-planning/sales-reps', params);
            if(response?.data){
                for(let o of response.data){
                    permanentsAgents.push(PermanentAgent.FromJson(o));
                }
            }
        }
        else{
            for(let op of OperationService.Operations){
                if(op.type === 'lgg'){
                    let temp = await this.loadPermanentsAgents(op.id);
                    if(temp.length > 0){
                        for(let t of temp){
                            if(!permanentsAgents.find(a => a.id === t.id)){
                                permanentsAgents.push(t);
                            }
                        }
                    }
                }
            }
        }        
        
        return permanentsAgents;
    } 
    
}
